import { isDevMode } from '@angular/core';
import { setupWorker } from 'msw/browser';

import { handlers } from './handlers';

const worker = setupWorker(...handlers);

export const enableMockWorker = async () => {
  if (isDevMode()) {
    console.log('MSWJS START');
    await worker.start({
      onUnhandledRequest: 'bypass'
    });
  } else {
    worker.stop();
  }
};
